import * as ng from 'angular';

const PLAN_FREE = 'free';
const PLAN_PAY_TO_JOIN = 'pay_to_join';

const privacyToPlan = {
    public: PLAN_FREE,
    protected: PLAN_PAY_TO_JOIN,
    private: PLAN_PAY_TO_JOIN,
};

interface ProductData {
    productId: number;
    label: string;
}

interface XYardsProduct {
    id: number;
    price: string;
    name: string;
}

const mapProduct = (product: XYardsProduct): ProductData => {
    return { productId: product.id, label: product.name };
};

/**
 * Component for selecting a subscription plan for a group.
 * It's a little bit messy already, since it's used for both create and update forms.
 */
export const GroupSubscriptionPlanSetupComponent: ng.IComponentOptions = {
    bindings: {
        onChanges: '&',
        privacy: '<',
        defaultProductId: '<',
        viewMode: '@?',
    },
    template: require('./group-subscription-plan-setup.component.html').default,
    controller: class GroupSubscriptionPlanSetupComponent implements ng.IComponentController {
        static $inject = ['$http'];

        private onChanges?: (v: { $value: any }) => void;
        private privacy: 'public' | 'private' | 'protected' = 'public';
        private viewMode: 'edit' | 'create' | string = 'create';

        // This is a static list of WooCommerce products related to group subscriptions.
        private availableProducts: ProductData[] = [];

        private subscription: { plan: string; product?: ProductData } = {
            plan: 'free',
        };

        private defaultProductId?: number;
        private _defaultProductId?: number;

        // something is loading
        private isLoading: boolean = false;

        constructor(private $http: ng.IHttpService) {}

        triggerChange() {
            this.onChanges && this.onChanges({ $value: this.subscription });
        }

        get requiresPaidPlan() {
            return this.privacy != 'public';
        }

        get planNeedsProduct() {
            return this.subscription.plan != 'free';
        }

        get isCreateView() {
            return this.viewMode === 'create';
        }

        get isEditView() {
            return this.viewMode === 'edit';
        }

        $onInit() {
            // store the default product ID during init and dont change it from now on.
            this._defaultProductId = this.defaultProductId;

            this._initFormData();
        }

        $onChanges(onChangesObj: ng.IOnChangesObject) {
            if (onChangesObj.privacy) {
                this._initFormData();
            }
        }

        private _initFormData() {
            this.subscription.plan = privacyToPlan[this.privacy] || PLAN_FREE;

            this._fetchSelectableProducts().then((products) => {
                this.availableProducts = products;
                this.subscription.product = this._defaultProduct;
                this.triggerChange();
            });

            this.triggerChange();
        }

        private get _defaultProduct() {
            return (
                this.availableProducts.find((p) => p.productId === this._defaultProductId) || this.availableProducts[0]
            );
        }

        /**
         * Gilbert needs it today, so there will be some copy-paste approach...
         */
        private _fetchSelectableProducts(): ng.IPromise<ProductData[]> {
            const params = { entry: 'group', recurring: 1 };

            this.isLoading = true;

            return this.$http
                .get<{ data: XYardsProduct[] }>('/api/v1.0/xyards/products', { params })
                .then((response) => response.data.data)
                .then((products) => {
                    return products.map(mapProduct);
                })
                .finally(() => (this.isLoading = false));
        }
    },
};
